// app/javascript/controllers/validators/address_validator_controller.js
import {Controller} from "@hotwired/stimulus"
import {formValidation, plugins} from "../../../../vendor/javascript/@form-validation/esm/bundle/popular"
import * as Bootstrap5 from "../../../../vendor/javascript/@form-validation/esm/plugin-bootstrap5/index.js"

// Connects to data-controller="validators--account-shipping"
export default class extends Controller {
    static targets = ["form"]

    connect() {
        console.log('AccountShippingController connected');
        this.initializeValidation();

        // Listen for the address:stateFieldChanged event from the address controller
        this.element.addEventListener('address:stateFieldChanged', this.handleStateFieldChanged.bind(this));
    }

    initializeValidation() {
        const form = document.getElementById('frm-profile-shipping');
        if (!form) {
            console.error('Shipping profile form element not found');
            return;
        }

        // Initialize form validation
        this.validation = formValidation(form, {
            fields: {
                'user[detail_attributes][ship_firstname]': {
                    validators: {
                        notEmpty: {
                            message: 'The first name is required'
                        }
                    }
                },
                'user[detail_attributes][ship_lastname]': {
                    validators: {
                        notEmpty: {
                            message: 'The last name is required'
                        }
                    }
                },
                'user[detail_attributes][ship_dayphone]': {
                    validators: {
                        notEmpty: {
                            message: 'The telephone number is required for Fedex.'
                        }
                    }
                },
                'user[detail_attributes][ship_address1]': {
                    validators: {
                        notEmpty: {
                            message: 'The street address is required.'
                        }
                    }
                },
                'user[detail_attributes][ship_city]': {
                    validators: {
                        notEmpty: {
                            message: 'The city is required.'
                        }
                    }
                },
                'user[detail_attributes][ship_state]': {
                    validators: {
                        notEmpty: {
                            message: 'The State is required.'
                        }
                    }
                },
                'user[detail_attributes][ship_zipcode]': {
                    validators: {
                        notEmpty: {
                            message: 'The zip code is required.'
                        }
                    }
                }
            },
            plugins: {
                trigger: new plugins.Trigger({
                    event: 'blur'
                }),
                submitButton: new plugins.SubmitButton(),
                bootstrap5: new Bootstrap5.Bootstrap5({
                    rowSelector: '.mb-3',
                    eleInvalidClass: 'is-invalid',
                    eleValidClass: 'is-valid'
                })
            }
        })
            .on('core.form.valid', (e) => {
                // Form is valid, proceed with submission
                //form.submit();
                const submitEvent = new Event('submit', {bubbles: true, cancelable: true});
                form.dispatchEvent(submitEvent);
            })
            .on('core.form.invalid', (e) => {
                // Form is invalid, prevent submission
                e.preventDefault();
                return false;
            });

        // Store the FormValidation instance on the form element
        // This allows our address_validator_controller to access it
        form._formValidation = this.validation;
    }

    /**
     * Handle state field changes from the address controller
     */
    handleStateFieldChanged(event) {
        if (!this.validation) return;

        const fieldName = event.detail.fieldName;

        // Reapply validation to the state field
        setTimeout(() => {
            try {
                this.validation.removeField(fieldName);
            } catch (e) {
                console.warn('Field was not yet registered for validation', e);
            }

            this.validation.addField(fieldName, {
                validators: {
                    notEmpty: {
                        message: 'The State/Province is required.'
                    }
                }
            });
        }, 100);
    }

    disconnect() {
        if (this.validation) {
            this.validation.destroy();
        }

        this.element.removeEventListener('address:stateFieldChanged', this.handleStateFieldChanged);
    }
}